import {
  type SurveyLanguage,
  useSurveyEndpoints,
} from "@inrange/building-manager-api-client";
import { useState } from "react";
import Form from "react-bootstrap/Form";

/**
 * Per-endpoint language picker. Driven by survey_endpoint.default_language
 * via PUT /survey/endpoints/{id}/language. Null on the DB side is treated as
 * English for display.
 */
const SurveyEndpointLanguageSelector = ({
  endpointId,
  currentLanguage,
  label,
  minWidth = 140,
}: {
  endpointId: string;
  currentLanguage: SurveyLanguage | null;
  label?: string;
  minWidth?: number;
}) => {
  const { updateEndpointLanguage } = useSurveyEndpoints();
  const [error, setError] = useState<string | null>(null);

  const handleChange = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setError(null);
    const next = event.target.value as SurveyLanguage;
    if (next === (currentLanguage ?? "en")) return;
    try {
      await updateEndpointLanguage.mutateAsync({
        endpointId,
        defaultLanguage: next,
      });
    } catch (err) {
      setError(String(err));
    }
  };

  const isPending =
    updateEndpointLanguage.isLoading &&
    updateEndpointLanguage.variables?.endpointId === endpointId;

  return (
    <div style={{ minWidth }}>
      {label && <Form.Label className="small mb-1">{label}</Form.Label>}
      <Form.Select
        size="sm"
        value={currentLanguage ?? "en"}
        onChange={handleChange}
        disabled={isPending}
        aria-label="Survey language"
      >
        <option value="en">English</option>
        <option value="nl">Dutch</option>
      </Form.Select>
      {error && <div className="text-danger small mt-1">{error}</div>}
    </div>
  );
};

export default SurveyEndpointLanguageSelector;
